import { createSelector } from 'redux-bundler';

export const selectTwilioRegisteredBrandOptions = createSelector(
  'selectCurrentOrganizationId',
  'selectOrganizationsById',
  (id, byId) =>
    byId[id]?.twilioRegistrations?.map((item) => ({
      label: item.legalBusinessName,
      value: item.id,
    })) || [],
);
